module.exports = __webpack_public_path__ + "img/img (28).79d11bdd.jpg";